// extracted by mini-css-extract-plugin
module.exports = {"header":"GlobalHeader_header_10wGx","wrap":"GlobalHeader_wrap_1jYGK","logo":"GlobalHeader_logo_34zvv"};